// extracted by mini-css-extract-plugin
export default {"content":"CrzI5Zfa3N4rZ_HNJ5bu","scrollArea":"qgCfnphLMmQUntV8jndR","metaGrid":"nOCRVUCF4JQpBMpBr6WA","cta":"JEgyzMIRvsgOumxB_uRV"};